
import React from 'react';
import { Button, Icon, Popup } from 'semantic-ui-react';
import { useTextResources } from '../../language';

export const IconButton = ({ onClick, children, content, popupProps = {}, literalContent, style = {}, resetStyles = true, type = 'submit', ...rest }) => {
  const text = useTextResources();

  // Define default styles
  const defaultButtonStyles = resetStyles
    ? {
      background: 'none',
      border: 'none',
      padding: 0,
      boxShadow: 'none',
    }
    : {};

  return (
    <Popup
      content={literalContent || text(content)}
      {...popupProps}
      trigger={
        <Button
          onClick={(e) => {
            e.stopPropagation(); //Prevent event to go all the way up and initiate other event-listeners
            onClick?.();
          }}
          icon
          style={{
            ...defaultButtonStyles,
            ...style,
          }}
          type={type}
          {...rest}
        >
          {children}
        </Button>
      }
    />
  );
};

export const TrashButton = (props) => {
  return (
    <IconButton content={props?.content || 'Remove'} {...props}>
      <Icon link name='trash' />
    </IconButton>
  );
};

export const EditButton = (props) => {
  return (
    <IconButton content={props?.content || 'Edit'} {...props}>
      <Icon link name='pencil' />
    </IconButton>
  );
};
export const BookmarkButton = (props) => {
  return (
    <IconButton content={props?.content || 'Register'} {...props}>
      <Icon link name='bookmark' />
    </IconButton>
  );
};

export const PercentButton = (props) => {
  return (
    <IconButton content={props?.content || 'Percent'} {...props}>
      <Icon link name='percent' />
    </IconButton>
  );
};
export const RegisterButton = (props) => {
  return (
    <IconButton content={props?.content || 'Register'} {...props}>
      <Icon link name='sign-in' />
    </IconButton>
  );
};

export const LeftChevronButton = (props) => {
  return (
    <IconButton content={props?.content || 'Left'} {...props}>
      <Icon link name='chevron left' />
    </IconButton>
  );
};

export const RightChevronButton = (props) => {
  return (
    <IconButton content={props?.content || 'Right'} {...props}>
      <Icon link name='chevron right' />
    </IconButton>
  );
};

export const CheckButton = (props) => {
  return (
    <IconButton content={props?.content || 'Save'} {...props}>
      <Icon link name='check' />
    </IconButton>
  );
};

export const CancelButton = (props) => {
  return (
    <IconButton content={props?.content || 'Cancel'} type='button' {...props}>
      <Icon link name='cancel' />
    </IconButton>
  );
};

export const CopyButton = (props) => {
  return (
    <IconButton content={props?.content || 'Copy'} {...props}>
      <Icon link name='copy' />
    </IconButton>
  );
};
export const AddButton = (props) => {
  return (
    <IconButton content={props?.content || 'Add'} {...props}>
	  <Add />
	</IconButton>
  );
};
